import axios from 'axios';
import crypto from 'crypto-js';
import config from '../../config';

const APP_ENV = process.env.VUE_APP_ENV;
const { CRM_API_URL, CRM_APP_KEY, CRM_APP_PWD } = config[APP_ENV];

const projectName = '';
const baseURL = `${CRM_API_URL}${projectName}`;

const service = axios.create({
  baseURL,
  // withCredentials: true,
  timeout: 10000,
});

service.defaults.retry = 1;
service.defaults.retryDelay = 1000;

service.interceptors.request.use(
  (config) => {
    // baseURL为空的认为是外网URL，不需要请求头, 新请求才需要，boss老接口不用
    if (config.baseURL === baseURL) {
      const accessToken = localStorage.getItem('accessToken') || '';
      if (accessToken) {
        config.headers.accessToken = accessToken;
      }
      config.headers.appKey = CRM_APP_KEY;
      if (config.data && typeof config.data === 'string') {
        config.data = JSON.parse(config.data);
      }
      config.headers.apiSign = getApiSign(config);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (res.code === 50003) {
      console.log('res', res);
      // let redirectUrl = location.href;
      // if (location.href.indexOf('?redirect=') > -1) {
      //   redirectUrl = location.href.split('?redirect=')[0];
      // }
      // window.location.href = `/login?redirect=${encodeURIComponent(redirectUrl)}`;
      return res;
    }
    return res;
  },
  (err) => {
    const config = err.config;
    // 如果没有retry，就直接放回错误，默认会有，除非被重置
    if (!config || !config.retry) return Promise.reject(err);
    console.log('retry', config.url);
    // 如果有错误信息，不是超时，直接返回错误
    if (err.response?.data) {
      return Promise.reject(err);
    }

    config.__retryCount = config.__retryCount || 0;

    if (config.__retryCount >= config.retry) {
      // ElMessage.error('网络请求失败，请稍后再试!');
      return false;
    }

    config.__retryCount += 1;

    const backoff = new Promise(function (resolve) {
      setTimeout(function () {
        resolve();
      }, config.retryDelay || 1);
    });

    return backoff.then(function () {
      return service(config);
    });
  },
);

function getApiSign(config) {
  let str;
  if (config.method === 'get') {
    const params = config.params;
    str = Object.keys(params)
      .sort()
      .map((key) => `${key}=${params[key]}`)
      .join('&');
  } else {
    if (config.data instanceof FormData) {
      const formdata = config.data;
      const keys = [];
      for (let key of formdata.keys()) {
        keys.push(key);
      }
      str = keys
        .sort()
        .map((key) => `${key}=${formdata.get(key)}`)
        .join('&');
    } else {
      str = JSON.stringify(config.data);
    }
  }
  return crypto.MD5(CRM_APP_PWD + str + CRM_APP_PWD).toString();
}

export default service;
